module.exports = __webpack_public_path__ + "static/media/text_container_long_flipped.16624f8d.png";